import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Grid } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
}));

export default function FormularioSeguimiento(props) {
  const {
    register,
    errors,
    defaultItem,
    ctl,
    watch,
    setValue,
    id,
    getValues,
  } = props;
  const classes = useStyles();

  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const fechaActual = year + "-" + month + "-" + day;
  var fechamin = ctl.infosol?.fecha_inicio;
  var fechamax = ctl.infosol
    ? ctl.infosol.fecha_max_ma
      ? ctl.infosol.fecha_max_ma
      : ctl.infosol.fecha_fin
    : "2090-12-31";

  const handleChange = (event, value) => {
    if (value.length > 0) {
      setValue("responsables", value);
    } else setValue("responsables", null);
  };
  const isEdicion = defaultItem.titulo ? true : false;
  
  return (
    <Grid container className={classes.root} spacing={2}>
      <TextField
        error={false}
        defaultValue={id}
        style={{ display: "none" }}
        id="outlined-error-helper-text"
        label="TÍTULO"
        variant="outlined"
        fullWidth
        name="idsolicitud"
        inputRef={register({
          required: {
            value: true,
            message: "Título es requerido",
          },
          minLength: {
            value: 1,
            message: "Mínimo 1 carácteres",
          },
        })}
      />

      <Grid item lg={12} xs={12}>
        <TextField
          defaultValue={defaultItem.titulo}
          id="outlined-error-helper-text"
          label="TÍTULO"
          variant="outlined"
          fullWidth
          name="titulo"
          inputRef={register({
            required: {
              value: true,
              message: "Título es requerido",
            },
            minLength: {
              value: 1,
              message: "Mínimo 1 carácteres",
            },
          })}
          error={Boolean(errors.titulo)}
          helperText={errors.titulo}
        />

        {/* {errors.titulo && <p style={{color:"red"}}>"Campo requerido" </p>} */}
      </Grid>

      <Grid item lg={4} xs={4}>
        <TextField
          value={watch("fecha_inicio")}
          id="outlined-error-helper-text"
          label="FECHA DE INICIO"
          disabled={isEdicion}
          variant="outlined"
          fullWidth
          name="fecha_inicio"
          type="date"
          onChange={(e) => {
            setValue("fecha_inicio", e.target.value);
            setValue("fecha_termino", e.target.value);
          }}
          inputRef={register()}
          error={Boolean(errors.fecha_inicio)}
          helperText={errors.fecha_inicio}
        />
        {/* {errors.prop_fin && <p style={{color:"red"}}>"Campo requerido" </p>} */}
      </Grid>
      <Grid item lg={4} xs={4}>
        <TextField
          value={watch("fecha_termino")}
          id="outlined-error-helper-text"
          label="FECHA DE TÉRMINO"
          variant="outlined"
          fullWidth
          disabled={isEdicion}
          name="fecha_termino"
          type="date"
          InputProps={{
            inputProps: {
              min: defaultItem.fecha_inicio
                ? defaultItem.fecha_inicio
                : fechamin,
            },
          }}
          inputRef={register({
            required: {
              value: true,
              message: "F. fin es requerida",
            },
            minLength: {
              value: 1,
              message: "Mínimo 1 carácteres",
            },
          })}
          error={Boolean(errors.fecha_termino)}
          helperText={errors.fecha_termino}
        />
        {/* {errors.prop_fin && <p style={{color:"red"}}>"Campo requerido" </p>} */}
      </Grid>

      <Grid item lg={4} xs={4}>
        <TextField
          defaultValue={defaultItem.nhoras_seguimiento}
          id="outlined-error-helper-text"
          label="# HORAS TRABAJO"
          variant="outlined"
          disabled={isEdicion}
          fullWidth
          name="nhoras_seguimiento"
          type="number"
          inputRef={register({
            required: {
              value: true,
              message: "N. de horas es requerido",
            },
            minLength: {
              value: 1,
              message: "Mínimo 1 carácteres",
            },
            min: {
              value: 1,
              message: "MÍNIMO 1 HORA",
            },
          })}
          error={Boolean(errors.nhoras_seguimiento)}
          helperText={errors.nhoras_seguimiento}
        />
        {/* {errors.nhoras_tarea && <p style={{color:"red"}}>"Campo requerido" </p>} */}
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          options={ctl.tipoSeguimiento}
          getOptionLabel={(option) => option.nseguimiento}
          getOptionSelected={(option, value) =>
            option.idseguimiento == value.idseguimiento
          }
          defaultValue={{
            idseguimiento: defaultItem.idseguimiento,
            nseguimiento: defaultItem.nseguimiento,
          }}
          onChange={(e, v) =>
            v?.idseguimiento
              ? setValue("tipoSeguimiento", v.idseguimiento)
              : setValue("tipoSeguimiento", null)
          }
          inputRef={register("tipoSeguimiento")}
          size="small"
          fullWidth
          renderInput={(params) => (
            <TextField
              label="TIPO DE SEGUIMIENTO"
              variant="outlined"
              {...params}
              error={errors.tipoSeguimiento != undefined}
              helperText={errors.tipoSeguimiento}
            />
          )}
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <Autocomplete
          multiple
          options={ctl.personas}
          getOptionLabel={(option) => option.nombre}
          getOptionSelected={(option, value) =>
            option.idpersona == value.idpersona
          }
          defaultValue={defaultItem?.responsables}
          onChange={handleChange}
          size="small"
          fullWidth
          inputRef={register("responsables")}
          renderInput={(params) => (
            <TextField
              label="MIEMBROS DEL EQUIPO"
              variant="outlined"
              {...params}
              error={errors.responsables != undefined}
              helperText={errors.responsables}
            />
          )}
        />
      </Grid>

      <Grid item lg={12} xs={12}>
        <TextField
          multiline
          rows={3}
          defaultValue={defaultItem.involucrados}
          id="outlined-error-helper-text"
          label="EXTERNOS"
          variant="outlined"
          fullWidth
          name="involucrados"
          inputRef={register({
            required: {
              value: true,
              message: "Externos es requerido",
            },
            minLength: {
              value: 1,
              message: "Mínimo 1 carácteres",
            },
          })}
          error={Boolean(errors.involucrados)}
          helperText={errors.involucrados}
        />
        {/* {errors.descripcion && <p style={{color:"red"}}>"Campo requerido" </p>} */}
      </Grid>
      <Grid item lg={12} xs={12}>
        <TextField
          multiline
          rows={3}
          defaultValue={defaultItem.observaciones}
          id="outlined-error-helper-text"
          label="OBSERVACIONES"
          variant="outlined"
          fullWidth
          name="observaciones"
          inputRef={register({
            required: {
              value: true,
              message: "Observaciones es requerido",
            },
            minLength: {
              value: 1,
              message: "Mínimo 1 carácteres",
            },
          })}
          error={Boolean(errors.observaciones)}
          helperText={errors.observaciones}
        />
      </Grid>
    </Grid>
  );
}
